import React from "react";
const AssetNavbar = ({ activePage, setActivePage }) => {
  const pageName = ["Overview", "Asset remark", "Summary"];
  return (
    <div className="newUiBody">
      {pageName.map((page) => {
        return (
          <button
            className={` ms-1 btn btn-sm btn-outline-dark Subject ${
              activePage === page && "active"
            }`}
            onClick={() => {
              setActivePage(page);
            }}
          >
            {page}
          </button>
        );
      })}
    </div>
  );
};
export default AssetNavbar;
